<div class="success-container">
  <div class="success-visual">
    <div class="custom-icon success_lrg"></div>
  </div>

  @if (!order) {
    <div class="success-text">
      <h1>Ticket Submitted!</h1>
      <h2>
        Your ticket has been created and sent. We will keep you updated on the
        status of your ticket as we proceed. If you created a disconnect ticket,
        check the orders page for updates.
      </h2>
      <button class="primary-button" (click)="onClosed()">OK</button>
    </div>
  } @else {
    <div class="success-text">
      <h1>Order Submitted!</h1>
      @if (order.Id) {
        <h2>
          Your order
          <a routerLink="/orders/{{ order.Id }}" (click)="onClosed()">
            {{ order.Name }}</a
          >
          has been created and sent. We will keep you updated on the status of
          your order as we proceed.
        </h2>
      } @else {
        <h2>
          Your <a routerLink="/orders" (click)="onClosed()">order</a> has been
          created and sent. We will keep you updated on the status of your order
          as we proceed.
        </h2>
      }
      <button class="primary-button" (click)="onClosed()">OK</button>
    </div>
  }
</div>
